import { runItem } from 'api';
import { IData } from 'types';
import useAxios from './useAxios';

const useRunItem = () => {
  const [request, { loading, error }] = useAxios();

  const handleRunItem = async (data: IData) => {
    const item = await request(runItem(data));

    return item;
  };

  return [handleRunItem, { loading, error: error?.data?.message }] as const;
};

export { useRunItem };
